import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";
import { MENU_CONSTANT } from "../constants/menu.constant";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  constructor(private http: HttpClient) {}
  getPermissionData(filterObj) {
    return this.http.post(`${MENU_CONSTANT.ROLE_LIST}`, filterObj);
  }
  public getMenuPageConfig() {
    return this.http.get(PAGE_CONFIG.Permissionmenu_Page);
  }
  public getModules() {
    return this.http.get(`${MENU_CONSTANT.GET_ROLES}`);
  }

  public createRole(body) {
    return this.http.post(`${MENU_CONSTANT.CREATE_ROLE}`, body);
  }
  public getEditData(id) {
    return this.http.get(`${MENU_CONSTANT.GET_DATA}/${id}`);
  }
  public roleCheck(obj) {
    return this.http.post(`${MENU_CONSTANT.ROLE_CHECK}`, obj);
  }
}
